import { API_ENDPOINTS } from "../constants/endpoints";
import {
  FTC_KPI_ANALYSIS_ENDPOINT_MAP,
  FTC_KPI_FACTOIDS_ENDPOINT_MAP,
  FTC_KPI_GRAPH_ENDPOINT_MAP,
  FTC_KPI_GRAPH_FILTER_ENDPOINT_MAP,
  FTC_KPI_TABLE_ENDPOINT_MAP,
  FTC_KPI_TABLE_FILTER_ENDPOINT_MAP,
} from "../constants/KpiEnpointMapper";
import api from "../lib/axios";

export const getKpiList = (countryName: string | undefined) => {
  let endpoint = API_ENDPOINTS.FINANCIAL.GET_KPI_LIST;

  if (countryName) {
    endpoint = `${endpoint}?party=${countryName}`;
  }

  return api.get(endpoint);
};

export const getKpiGraphFilters = (
  kpiId: number,
  filterName: string,
  filterValue?: string,
  countryName?: string
) => {
  const kpiEndpoint = FTC_KPI_GRAPH_FILTER_ENDPOINT_MAP[kpiId];
  let url = `${kpiEndpoint}?FilterName=${filterName}`;

  if (filterValue) {
    url = `${kpiEndpoint}?FilterName=${filterName}&FilterValue=${filterValue}`;
  }

  if (countryName) {
    url = `${url}&party=${countryName}`;
  }

  return api.get(url);
};

export const getKpiGraphData = (kpiId: number, filters: any) => {
  const kpiEndpoint = FTC_KPI_GRAPH_ENDPOINT_MAP[kpiId];

  const payload = {
    ...filters,
    viewBy: Array.isArray(filters.viewBy) ? filters.viewBy[0] : filters.viewBy,
    toYear: Number(
      Array.isArray(filters.toYear) ? filters.toYear[0] : filters.toYear
    ),
    fromYear: Number(
      Array.isArray(filters.fromYear) ? filters.fromYear[0] : filters.fromYear
    ),
  };

  return api.post(kpiEndpoint, payload);
};

export const getFactoids = (kpiId: number, countryName?: string) => {
  let url = FTC_KPI_FACTOIDS_ENDPOINT_MAP[kpiId];

  if (countryName) {
    url = `${url}?party=${countryName}`;
  }

  return api.get(url);
};

export const getKpiTableData = (kpiId: number, payload: any) => {
  const kpiEndpoint = FTC_KPI_TABLE_ENDPOINT_MAP[kpiId];
  return api.post(kpiEndpoint, payload);
};

export const getKpiFilters = (kpiId: number, countryName?: string) => {
  let url = FTC_KPI_TABLE_FILTER_ENDPOINT_MAP[kpiId];

  if (countryName) {
    url = `${url}?party=${countryName}`;
  }
  return api.get(url);
};

export const exportTableData = (kpiId: number, payload: any) => {
  const kpiEndpoint = FTC_KPI_TABLE_ENDPOINT_MAP[kpiId];
  return api.post(kpiEndpoint, payload);
};

export const getKpiGraphAnalysis = (kpiId: number, payload: any) => {
  const kpiEndpoint = FTC_KPI_ANALYSIS_ENDPOINT_MAP[kpiId];

  const { filters, requestId, sessionId } = payload;

  const updatedPayload = {
    ...filters,
    viewBy: Array.isArray(filters.viewBy) ? filters.viewBy[0] : filters.viewBy,
    toYear: Number(
      Array.isArray(filters.toYear) ? filters.toYear[0] : filters.toYear
    ),
    fromYear: Number(
      Array.isArray(filters.fromYear) ? filters.fromYear[0] : filters.fromYear
    ),
    RequestId: requestId,
    SessionId: sessionId,
  };

  return api.post(kpiEndpoint, updatedPayload);
};
